import PropTypes from 'prop-types';
import { withErrorBoundary } from 'react-error-boundary';

import { showTopLevelNavigation } from 'global-config';
import TabsMenu from './tabs_menu';
import ErrorBoundaryFallback from './error_boundary_fallback';

const ContentLayout = ({ showTabs, children }) => (
  <div className="react-contents">
    {showTabs && showTopLevelNavigation && <TabsMenu />}
    {children}
  </div>
);

ContentLayout.propTypes = {
  showTabs: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

ContentLayout.defaultProps = {
  showTabs: false,
};

export default withErrorBoundary(ContentLayout, {
  FallbackComponent: ErrorBoundaryFallback,
});
